import { GlobalResponseObject } from "../../global-response-object";
import { DivisionWiseRevenueDetailsResp } from "./division-wise-revenue-details.resp";


export class DivDetailResponse extends GlobalResponseObject{
data?:DivisionWiseRevenueDetailsResp[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:DivisionWiseRevenueDetailsResp[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}